import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Carousel from 'components/common/Carousel'
import PromotionSpotlightStyles from 'components/common/PromotionSpotlight/PromotionSpotlightStyles'
import { LazyDiv } from 'components/common/LazyHtml'

const ScrollableBrandPromotionSpotlight = ({ items = [], handlePromotionClick }) => {
  const promotions = items.map(({ data, ...promotion }, index) =>
    <PromoItem
      key={ index }
      content={ data }
      onClick={ event => handlePromotionClick({ event, item: promotion, index }) } />
  )

  return (
    <Wrapper>
      <Media.Desktop>
        <Content>
          { promotions }
        </Content>
      </Media.Desktop>
      <Media.Mobile>
        <CustomCarousel>
          { promotions }
        </CustomCarousel>
      </Media.Mobile>
    </Wrapper>
  )
}

export default ScrollableBrandPromotionSpotlight

ScrollableBrandPromotionSpotlight.propTypes = {
  handlePromotionClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object)
}

const Wrapper = styled.div`
  padding-top: 30px;
  text-align: center;
  ${Media.desktop`
    padding-top: 33px;
  `}
`

const Content = styled.div`
  display: inline-block;
`

const PromoItem = styled(LazyDiv)`
  display: inline-block;
  width: 450px;
  max-width: 90vw;
  ${PromotionSpotlightStyles}
  ${Media.desktop`
    width: 312px;

    &:not(:first-child) {
      margin-left: 24px;
    }
  `}
`

const CustomCarousel = styled(Carousel)`
  max-width: 90vw;
  margin: 0 auto;

  .slick-dots {
    bottom: -23px;
    left: 0;

    li {
      width: 12px;
      height: 12px;
    }

    li button {
      width: 12px;
      height: 12px;
    }

    li:not(.slick-active) button {
      background-color: ${Theme.colors.light_grey};
    }
  }
`
